/**
 * A labeled metric tile used inside the mobile list cards (Products, Orders,
 * Inventory). One definition so every mobile card has identical padding,
 * border and label styling — change the look here, not in three pages.
 */
export function MobileMetric({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div className="min-w-0 rounded-md border border-border bg-muted/30 p-2">
      <p className="mb-1 text-[10px] font-medium uppercase text-muted-foreground">
        {label}
      </p>
      <div className="min-w-0">{children}</div>
    </div>
  );
}
